// ResponseTimeChart.jsx
import React from 'react';
import { Line } from 'react-chartjs-2';

const ResponseTimeChart = ({ data }) => {
    return <Line data={data} />;
};

export default ResponseTimeChart;